export default __webpack_public_path__ + "./images/hn.95814a14.png";